module.exports = __webpack_public_path__ + "static/media/jetson_one_render_16.06cf8b41.jpg";